import { Component, Output, ElementRef, ViewChild, EventEmitter, OnInit, AfterViewInit, DoCheck, OnDestroy, Inject } from '@angular/core';
import { ArticleService } from '../article.service';
import { NavService } from '../../header/nav/nav.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { BreadcrumbService } from '../../header/breadcrumb/breadcrumb.service';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/switchMap';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../../header/topnav/topnav.service';
import { SharedService } from '../../common/shared.service';
import { APP_CONFIG, AppConfig } from '../../config/app.config.module';
import { PortalService } from '../../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';
import { Title } from '@angular/platform-browser';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Content Sub Category - subcategory/:id1
 **/
@Component({
  selector: 'app-article',
  templateUrl: './subarticle.component.html',
  styleUrls: ['./subarticle.component.css']
})
export class SubarticleComponent implements OnInit, AfterViewInit, DoCheck, OnDestroy {
  @ViewChild('scrollpanel', { read: ElementRef }) public scrollpanel: ElementRef;
  showLeftRightButton: boolean = false;
  cansubmit: boolean = true;
  isComplete: boolean = true;
  public imgSrcLike: string = 'assets/images/rating/Suka_Gray.png';
  public imgSrcNeutral: string = 'assets/images/rating/Neutral_Gray.png';
  public imgSrcDislike: string = 'assets/images/rating/Tidak_Suka_Gray.png';
  le_menu_code: any;
  le_code: any;
  le_content: any;
  agencyActive: boolean = false;
  statusID: any;
  @Output() menuClick = new EventEmitter();
  breadcrumb: any;
  isValid: any;
  public scoreFormgrp: FormGroup;
  score: FormControl;
  remarks: FormControl;
  topicID: number;
  subID: number;
  step = 0;
  articles: any[];
  moduleName: string;
  articleData: any;

  @Output() langChange = new EventEmitter();
  loading = false;
  leAgency: any;

  handleClickMe(e) {

  }
  boolCallback = (result: boolean) : void => {
    this.loading = result;
  }

  //private subscription: ISubscription;
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  lang;
  langId;

  public currentPath: string='';
  public menuLink = '';
  public myflag: any;

  public subArticleLoaded: boolean = false;
  private isColumnResizing: boolean = false; 
  private resizeTimer: any;

  constructor(private pageTitle: Title, private activatedRoute: ActivatedRoute, private sharedService: SharedService, public safeHtml: SafeHtmlPipe, private http: HttpClient, private toastr: ToastrService,  private portalService:PortalService, public articleService: ArticleService,private sharedservice: SharedService, @Inject(APP_CONFIG) private config: AppConfig, private topnavservice: TopnavService, private route: ActivatedRoute, public navService: NavService, private translate: TranslateService, private router: Router, private breadcrumbService: BreadcrumbService) {
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    router.events.subscribe( (event) => {
        if (event instanceof NavigationStart) {
          if (this.articleService) {
            this.articleService.leContent = "";
          }  
        }
      });

    this.lang = translate.currentLang;
    this.langId = 1;

    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;
      this.articleService.leContent = "";

      if (myLang == 'en') {
        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langId = 1;
          this.moduleName = this.router.url.split('/')[1];
          var tt = this.router.url.split('/');
          this.subID = parseInt(tt[tt.length - 1]);

        });

      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langId = 2;
          this.moduleName = this.router.url.split('/')[1];
          this.topicID = parseInt(this.router.url.split('/')[2]);
          var tt = this.router.url.split('/');
          this.subID = parseInt(tt[tt.length - 1]);
        });
      }

      if (this.topnavservice.flagLang) {

        if (!this.subArticleLoaded) {
          console.log('return if subArticle not yet loaded');
          return;
        }
        
        if (location.pathname.indexOf('agency') !== -1) {
          this.agencyActive = true;
          this.navService.triggerSubArticleAgency(this.langId);
        }
        else if (this.moduleName == 'subcategory') {
          this.navService.triggerSubArticle(this.subID, this.langId);
        }

        /*if (location.pathname.indexOf('agency') !== -1) {
          this.agencyActive = true;
          this.navService.triggerSubArticleAgency(this.langId, 'noaudit');
        }
        else if (this.moduleName == 'subcategory') {
          this.navService.triggerSubArticle(this.subID, this.langId, 'noaudit');
        } else if (this.moduleName == 'content') {
          this.navService.triggerContent(this.subID, this.langId, 'noaudit');
        } else {
          this.navService.triggerArticle(this.moduleName, this.langId, this.topicID, 'noaudit');
        }*/
      }


      // this.navService.triggerSubArticle(this.topicID, this.subID, this.langId);

    });

    this.activatedRoute.params.subscribe(val => {
      if (this.moduleName == 'subcategory') {
        console.log(val);
        if (!val) {
          return;
        }
        this.updateToAnalytics();
        //this.router.navigate(['/subcategory', this.getValueFromId(val)], { queryParams: this.myflag });
       
        this.navService.getSubArticleUrl(this.getValueFromId(val), localStorage.getItem('langID'));
        if (location.pathname.indexOf('agency') !== -1) {
          this.agencyActive = true;
          this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
        } else {
          this.agencyActive = false;
          this.navService.triggerSubArticle(this.getValueFromId(val), localStorage.getItem('langID'));
        }
      }
       
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;

      $('.font-size-l').css('font-size', this.fontSize.sizeL);
      $('.font-size-m').css('font-size', this.fontSize.sizeM);
      $('.font-size-s').css('font-size', this.fontSize.sizeS);
      $('.font-size-s li').css('font-size', this.fontSize.sizeS);
      this.isColumnResizing = false;
      this.colEqualizer();
    });

  }

  ngDoCheck() {
    if (this.scrollpanel) {
      if (this.scrollpanel.nativeElement.scrollWidth > this.scrollpanel.nativeElement.clientWidth) {
        this.showLeftRightButton = true;
      } 
    }
   
  }

  ngOnInit() {
    if (window.location.host.startsWith('localhost')) {
      this.currentPath = "http://"+window.location.host + '/';  
    } else {
      this.currentPath = "https://"+window.location.host + '/portal/';
    }
   
    localStorage.setItem('leCode', '');
    if(!this.langId){
      if (localStorage.getItem('langID')) {
        this.langId = localStorage.getItem('langID');
      } else {
        this.langId = 1;
      }
    }


    this.articleData = this.articleService.getArticle();
    this.topicID = parseInt(this.router.url.split('/')[2]);
    this.moduleName = this.router.url.split('/')[1];
    var tt = this.router.url.split('/');
    this.subID = parseInt(tt[tt.length - 1]);

    this.score = new FormControl('', [Validators.required]);
    this.remarks = new FormControl('');
    this.scoreFormgrp = new FormGroup({
      score: this.score,
      remarks: this.remarks

    });
  
    setTimeout(()=>{
      if (location.pathname.indexOf('agency') !== -1) {
        this.agencyActive = true;
        this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
      } else {
        this.agencyActive = false;
        this.navService.triggerSubArticle(this.subID, localStorage.getItem('langID'));
      }
      this.subArticleLoaded = true;
    }, 400); 
  }

  onResize(event) {
    console.log('resize');
    
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(()=>{
      this.isColumnResizing = false;
      this.colEqualizer();
      clearTimeout(this.resizeTimer);
    }, 500);
  }

  colEqualizer() {
    if(this.isColumnResizing) {
      return;
    }
   
    $('.col-eq').each(function (index, el) {
      $('> * [class*=intro-box-content]', el).css('min-height','266px');
    });
    setTimeout(() => {
      
      this.isColumnResizing = true;
      $('.col-eq').each((index, el)=> {
        console.log(index);
        let tallest: number = 0;
          $('> * [class*=intro-box-content]', el).css('min-height','unset');
          $('> * [class*=intro-box-content]', el).each(function (i, e) {
            //console.log($(e).height());
            let testHeight = $(e).height();
            if (testHeight > tallest) {
              tallest = testHeight;
            }
          });
          tallest=tallest+20;
          if (tallest < 266) {
            tallest = 266;
          }
          $('> * [class*=intro-box-content]', el).css('min-height', tallest + 'px');
          console.log('tallest:');
          console.log(tallest);
          this.isColumnResizing = false;
      });
    }, 500);
  }

  ngAfterViewInit() {
    setTimeout(() => {
        this.sharedService.sentToGtag(); 
    }, 1000);

    this.sharedService.loadFontSizeData();
    this.menuLink = 'hotlink';
    this.isColumnResizing = false;
    this.colEqualizer();
       
  }

  updateToAnalytics(contentId?) {
    console.log('updateToAnalytics');
    setTimeout(() => {
      if (!contentId) {
        this.sharedService.sentToGtag();
      } else {
        this.sharedService.sentToGtag(contentId);
      }
    }, 1000); 
  }

  handleSymbol(safeText) {
    return safeText.replace(/\&/g, "*;");
  }

  formatSymbol(unsafeText) {
    return unsafeText.replace(/\*;/g, "&");
  }


  onPreviousSearchPosition(): void {
    this.scrollpanel.nativeElement.scrollLeft -= 120;
  }

  onNextSearchPosition(): void {
    this.scrollpanel.nativeElement.scrollLeft += 120;
  }

  getThemeName() {
    document.documentElement.style.setProperty('--progressbar-background', localStorage.getItem('themeColor'));
    return localStorage.getItem('themeName');
  }

  getRateReset(){

    this.scoreFormgrp.controls['score'].disable();
    this.scoreFormgrp.controls['remarks'].disable();
    this.cansubmit = false;
  }

  resetForm() {
    this.imgSrcLike = 'assets/images/rating/Suka-Gray.png';
    this.imgSrcNeutral = 'assets/images/rating/Neutral-Gray.png';
    this.imgSrcDislike = 'assets/images/rating/Tidak-Suka-Gray.png';
    this.scoreFormgrp.controls['score'].setValue('');
    this.scoreFormgrp.controls['remarks'].setValue('');
    this.scoreFormgrp.controls['score'].enable();
    this.scoreFormgrp.controls['remarks'].disable();
    this.cansubmit = true;
  }


  submitForm(formValues:any){

    let body = {
        "contentCode": null,
        "score": null,
        "remarks": null
    };

    body.contentCode = localStorage.getItem('leCode');
    body.score = parseInt(formValues.score);
    body.remarks = formValues.remarks;

    // let datasend = JSON.stringify(body);

      this.portalService.submitScore(body).subscribe(
        data => {

          this.sharedservice.errorHandling(data, (function(){
            this.getRateReset();
            //this.toastr.success(this.translate.instant('rating.msgsubmit'), '');
            this.sharedService.showSuccess(this.translate.instant('rating.msgsubmit'), '');
        }).bind(this));
      },
      error => {
        //this.sharedService.showError((error._body.statusDesc), '');

      });

  }

  getRate(val){
    if (val === 1) {
      this.imgSrcLike = 'assets/images/rating/Suka.png';
      this.imgSrcNeutral = 'assets/images/rating/Neutral-Gray.png'
      this.imgSrcDislike = 'assets/images/rating/Tidak-Suka-Gray.png';
    } else if (val === 0) {
      this.imgSrcLike = 'assets/images/rating/Suka-Gray.png';
      this.imgSrcNeutral = 'assets/images/rating/Neutral.png';
      this.imgSrcDislike = 'assets/images/rating/Tidak-Suka-Gray.png';
    } else if (val === -1) {
      this.imgSrcLike = 'assets/images/rating/Suka-Gray.png';
      this.imgSrcNeutral = 'assets/images/rating/Neutral-Gray.png'
      this.imgSrcDislike = 'assets/images/rating/Tidak-Suka.png';
    }
    this.scoreFormgrp.controls['remarks'].enable();
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }


  clickTopMenu(e){
    this.resetForm();
    this.articleService.leContent = "";
    this.router.navigate(['/category', e.categoryCode], { queryParams: this.myflag });
    event.preventDefault();
  }


  clickSideMenu(e, status, event) {
    this.articleService.leContent = "";
    this.navService.loader = true;
    this.agencyActive = false;
    this.statusID = status;
    this.navService.getSubArticleUrl(e.categoryId, localStorage.getItem('langID'));
    //this.navService.triggerSubArticle(e.categoryCode, localStorage.getItem('langID'));
    this.router.navigate(['/subcategory', e.categoryCode], { queryParams: this.myflag });
    event.preventDefault();
    this.resetForm();
  }

  clickContent(e, status, event){
    this.navService.lfcontent = true;
    this.resetForm();
    localStorage.setItem('leCode',e);
    event.preventDefault();
    this.articleService.leContent = "";
    this.navService.loader = true;
    let url = this.config.urlPortal + 'content/' + e + '?language=' + localStorage.getItem('langID')+'&type=lifeevent'
    return this.http.get(url).subscribe(data => {
      this.navService.loader = false;
      this.le_menu_code = e;
      this.articleService.leContent = data['contentCategoryResource']['results'][0]['content']['contentText'];
      this.le_code = data['contentCategoryResource']['results'][0]['content']['contentCode'];
      this.leAgency = data['contentCategoryResource']['results'][0]['content']['agency']['agencyApplications'];
      let title ='';
      title = this.generateTitle() +' | '+ data['contentCategoryResource']['results'][0]['content']['contentTitle'];
      this.pageTitle.setTitle(title);
      this.updateToAnalytics(e);
      this.sharedService.loadFontSizeData();
    },
    error => {
      this.navService.loader = false;
    });

  }

  generateTitle() {
    let title = 'MyGOV - ';
    let index = 0;
    if (this.articleService) {
      if (this.articleService.articles) {
        for(let article of this.articleService.articles) {
          for (let breadCrum of article.breadcrum) {
            if (index == 0) {
              title = title+breadCrum.breadcrumName;  
            } else {
              title = title+' | '+ breadCrum.breadcrumName;
            }
            index++;
          }
        }
        //title = title.slice(0, -1);
        return title;
      } else {
        return title;
      }
    } else {
      return title;
    }
    
  }


  clickSideMenuByAgency(e, status, event) {
    this.articleService.leContent = "";
    this.resetForm();
    this.navService.loader = true;
    this.agencyActive = true;
    this.navService.getSubArticleUrlByAgency(localStorage.getItem('langID'));
    //this.navService.triggerSubArticleAgency(localStorage.getItem('langID'));
    this.router.navigate(['/subcategory', 'agency'], { queryParams: this.myflag });
    event.preventDefault();
  }


  getModule(data){
    let a = data.split("/");
    return a[1];
  }

  getID(data){
    let a = data.split("/");
    return a[2];
  }
  getValueFromId(data) {
    return data.id1;
  }

  breadcrumLink(id1, id2, $event){

    if(this.getModule(id1) === 'category'){
      this.router.navigate(['/category', this.getID(id2)], { queryParams: this.myflag });
    }else if(this.getModule(id1) === 'subcategory'){
      this.router.navigate(['/subcategory', this.getID(id2)], { queryParams: this.myflag });
      //this.navService.getSubArticleUrl(this.getID(id2), localStorage.getItem('langID'));
      //this.navService.triggerSubArticle(this.getID(id2), localStorage.getItem('langID'));
    }
    $event.preventDefault();
  }

  appTracking(refCode){
    const readUrl = `${this.config.urlPortal}agencyapplication/tracking?refCode=${refCode}&source=life-event`;
    const req = this.http.post(readUrl,'')
      .subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log("Error occured");
        }
      );
  }


  clickContentFromMenu(pId, aId, event) {
    this.resetForm();
    this.navService.loader = true;
    this.articleService.leContent = "";
    // this.navService.triggerContent(aId, localStorage.getItem('langID'));
    // this.navService.getContentUrl(aId, localStorage.getItem('langID'));
    this.router.navigate(['/content', aId], { queryParams: this.myflag });
    event.preventDefault();
  }


  checkImgData(e) {
    const chkData = e.search('<img');
    if (chkData != -1) {
      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/article/subarticle/subarticle.component.ts